const courses = [
{
  title: "DCF Financial Modeling",
  slug: "dcf-financial-modeling",
  description: "Learn how to build a Discounted Cash Flow model from scratch.",
  requirements: [
    "Ability to calculate Weighted Average Cost of Capital (WACC)",
    "Familiarity with the Capital Asset Pricing Model (CAPM)"
  ],
  videoLink: "https://youtu.be/VtmYZ8X-pI0?si=hU7zbquuOmNsOH7N",
  templateLink: "https://www.dropbox.com/scl/fi/dfzapd246chrmdknclab2/DCF-Modeling-by-A.alamoudi.xlsx?rlkey=pcrzji87a4wzjkooie5yj7ue1&st=lklh66w3&dl=0",
  comingSoon: false,
overview: `
Welcome to Discounted Cash Flow (DCF) Financial Modeling — a concise, project-based course designed to be completed in approximately one hour. You'll learn how to forecast a company's financials, discount future cash flows to present value, and calculate enterprise value, equity value, and fair value per share. The course is structured into two parts: a brief introduction to DCF methodology and a hands-on Excel-based valuation project. You'll work through six key tasks: understanding DCF fundamentals, analyzing historical financials, building a five-year forecast, applying exit multiples, calculating free cash flows, and deriving enterprise and equity value. The course is led by Abdulrahman Alamoudi, a capital markets professional with deep experience in investment banking, equity research, and financial modeling. His approach emphasizes clarity, precision, and elegant execution in financial education.
`
},
  {
    title: "Excel Dashboard Design",
    slug: "excel-dashboard-design",
    description: "Build elegant, interactive dashboards using Excel.",
    requirements: ["Intermediate Excel", "Basic design sense"],
    videoLink: "",
    templateLink: "",
    comingSoon: true
  },
  {
    title: "Financial Ratios Analysis",
    slug: "financial-ratios-analysis",
    description: "Master key financial ratios to evaluate company performance.",
    requirements: ["Basic accounting", "Excel familiarity"],
    videoLink: "",
    templateLink: "",
    comingSoon: true
  },
  {
    title: "Comparable Company Analysis (CCA)",
    slug: "comparable-company-analysis",
    description: "Learn how to benchmark companies using valuation multiples.",
    requirements: ["Valuation basics", "Excel modeling"],
    videoLink: "",
    templateLink: "",
    comingSoon: true
  },
  {
    title: "Weighted Average Cost of Capital (WACC)",
    slug: "weighted-average-cost-of-capital",
    description: "Understand how to calculate and apply WACC in valuation models.",
    requirements: ["Corporate finance fundamentals", "Excel proficiency"],
    videoLink: "",
    templateLink: "",
    comingSoon: true
  }
];

export default courses;